import type { LucideIcon } from 'lucide-react';
import {
  ArrowLeftRight,
  BarChart3,
  BookOpen,
  Building2,
  FileInput,
  HandCoins,
  Landmark,
  LayoutDashboard,
  Package,
  Receipt,
  Settings,
  ShoppingCart,
  Wallet
} from 'lucide-react';

export type NavItem = {
  id: string;
  path: string;
  labelKey: string;
  icon: LucideIcon;
  enabled: boolean;
};

export const NAV_ITEMS: NavItem[] = [
  { id: 'dashboard', path: '/', labelKey: 'nav.dashboard', icon: LayoutDashboard, enabled: true },
  { id: 'cashbook', path: '/cashbook', labelKey: 'nav.cashbook', icon: HandCoins, enabled: true },
  { id: 'coa', path: '/coa', labelKey: 'nav.coa', icon: BookOpen, enabled: true },
  { id: 'journals', path: '/journals', labelKey: 'nav.journals', icon: Receipt, enabled: true },
  {
    id: 'sales',
    path: '/sales',
    labelKey: 'nav.salesAr',
    icon: ShoppingCart,
    enabled: true
  },
  {
    id: 'purchases',
    path: '/purchases',
    labelKey: 'nav.purchasesAp',
    icon: Building2,
    enabled: true
  },
  { id: 'inventory', path: '/inventory', labelKey: 'nav.inventory', icon: Package, enabled: true },
  { id: 'banking', path: '/banking', labelKey: 'nav.banking', icon: Landmark, enabled: true },
  { id: 'taxes', path: '/taxes', labelKey: 'nav.taxes', icon: ArrowLeftRight, enabled: true },
  { id: 'reports', path: '/reports', labelKey: 'nav.reports', icon: BarChart3, enabled: true },
  {
    id: 'import',
    path: '/import',
    labelKey: 'nav.importIntegrations',
    icon: FileInput,
    enabled: true
  },
  { id: 'fixedAssets', path: '/fixed-assets', labelKey: 'nav.fixedAssets', icon: Landmark, enabled: true },
  { id: 'payroll', path: '/payroll', labelKey: 'nav.payroll', icon: Wallet, enabled: true },
  { id: 'settings', path: '/settings', labelKey: 'nav.settings', icon: Settings, enabled: true }
];
